export const messages = {
  en: {
    finishRepair: {
      title: 'Repair Completion',
      materialUsage: 'Material Usage',
      selectMaterialUsage: 'Please select material usage',
      repairType: 'Repair Type',
      selectRepairType: 'Please select repair type',
      selectGoods: 'Select Goods',
      usedGoods: 'Used Goods',
      category: 'Category',
      goods: 'Goods',
      price: 'Price',
      quantity: 'Quantity',
      unit: 'Unit',
      spec: 'Spec',
      operation: 'Operation',
      totalAmount: 'Total Amount',
      paymentMethod: 'Payment Method',
      selectPaymentMethod: 'Please select payment method',
      suggestion: 'Suggestion',
      inputSuggestion: 'Required, please input suggestion',
      beforeRepairPhoto: 'Before Repair Photo',
      afterRepairPhoto: 'After Repair Photo',
      validate: {
        repairIdRequired: 'Repair ID is required',
        maintenanceTypeRequired: 'Maintenance type is required',
        contextRequired: 'Suggestion is required',
        beforePhotoRequired: 'Before repair photo is required',
        afterPhotoRequired: 'After repair photo is required',
        goodsRequired: 'Please select goods',
        paymentMethodRequired: 'Payment method is required'
      },
      submitSuccess: 'Submit successfully',
      submitError: 'Submit failed',
      page: {
        subtitle: 'Record maintenance type, materials used and completion photos'
      }
    },
    chooseSingleResource: {
      title: 'Select Item',
      goodsType: 'Goods Type',
      selectGoodsType: 'Please select goods type',
      goodsName: 'Goods Name',
      inputGoodsName: 'Required, please input goods name',
      subCategory: 'Sub Category',
      selectSubCategory: 'Please select sub category',
      goods: 'Goods',
      selectGoods: 'Please select goods',
      goodsPrice: 'Goods Price',
      customPrice: 'Custom Price',
      inputPrice: 'Required, please input price',
      priceRange: 'Price Range',
      spec: 'Spec',
      quantity: 'Quantity',
      custom: 'Custom',
      validate: {
        goodsTypeRequired: 'Goods type is required',
        subCategoryRequired: 'Sub category is required',
        goodsRequired: 'Goods is required',
        priceRequired: 'Price is required',
        goodsNameRequired: 'Goods name is required'
      }
    }
  },
  zh: {
    finishRepair: {
      title: '报修结单',
      materialUsage: '是否用料',
      selectMaterialUsage: '请选择是否用料',
      repairType: '维修类型',
      selectRepairType: '请选择维修类型',
      selectGoods: '选择商品',
      usedGoods: '使用商品',
      category: '分类',
      goods: '商品',
      price: '价格',
      quantity: '数量',
      unit: '单位',
      spec: '规格',
      operation: '操作',
      totalAmount: '商品总金额',
      paymentMethod: '支付方式',
      selectPaymentMethod: '请选择支付方式',
      suggestion: '处理意见',
      inputSuggestion: '必填，请填写处理意见',
      beforeRepairPhoto: '维修前图片',
      afterRepairPhoto: '维修后图片',
      validate: {
        repairIdRequired: '报修单不能为空',
        maintenanceTypeRequired: '维修类型不能为空',
        contextRequired: '处理意见不能为空',
        beforePhotoRequired: '维修前图片不能为空',
        afterPhotoRequired: '维修后图片不能为空',
        goodsRequired: '请选择商品',
        paymentMethodRequired: '请选择支付方式'
      },
      submitSuccess: '提交成功',
      submitError: '提交失败',
      page: {
        subtitle: '登记维修类型、所用材料与维修完成图片'
      }
    },
    chooseSingleResource: {
      title: '选择物品',
      goodsType: '商品类型',
      selectGoodsType: '请选择商品类型',
      goodsName: '商品名',
      inputGoodsName: '必填，请填写商品名',
      subCategory: '二级分类',
      selectSubCategory: '请选择二级类型',
      goods: '商品',
      selectGoods: '请选择商品',
      goodsPrice: '商品价格',
      customPrice: '自定义价格',
      inputPrice: '必填，请填写自定义价格',
      priceRange: '价格范围',
      spec: '规格',
      quantity: '商品数量',
      custom: '自定义',
      validate: {
        goodsTypeRequired: '商品类型不能为空',
        subCategoryRequired: '二级分类不能为空',
        goodsRequired: '商品不能为空',
        priceRequired: '商品价格不能为空',
        goodsNameRequired: '商品名不能为空'
      }
    }
  }
}